module.exports = __webpack_public_path__ + "img/gologo.a601c0c6.png";